'use strict';

exports.__esModule = true;
exports.GET_AUTHOR_INFO = exports.GET_SPECIALISTS_BLOG_AUTHORS = exports.GET_BLOG_AUTHORS = exports.UPDATE_INDEX = exports.GET_BLOG_POST_CATEGORIES = exports.GET_BLOG_MEDIA = exports.GET_BLOG_POSTS = undefined;

var _doctifyUtils = require('doctify-utils');

var GET_BLOG_POSTS = exports.GET_BLOG_POSTS = 'BLOG_BANNER:GET_BLOG_POSTS';
var GET_BLOG_MEDIA = exports.GET_BLOG_MEDIA = 'BLOG_BANNER:GET_BLOG_MEDIA';
var GET_BLOG_POST_CATEGORIES = exports.GET_BLOG_POST_CATEGORIES = 'BLOG_BANNER:GET_BLOG_POST_CATEGORIES';
var UPDATE_INDEX = exports.UPDATE_INDEX = 'BLOG_BANNER:UPDATE_INDEX';
var GET_BLOG_AUTHORS = exports.GET_BLOG_AUTHORS = 'BLOG_BANNER:GET_BLOG_AUTHORS';
var GET_SPECIALISTS_BLOG_AUTHORS = exports.GET_SPECIALISTS_BLOG_AUTHORS = 'BLOG_BANNER:GET_SPECIALISTS_BLOG_AUTHORS';
var GET_AUTHOR_INFO = exports.GET_AUTHOR_INFO = 'BLOG_BANNER:GET_AUTHOR_INFO';

var blogBannerActions = {
	getBlogAuthors: function getBlogAuthors(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'blog/authors',
			method: 'GET',
			actionType: GET_BLOG_AUTHORS,
			keyword: 'author',
			xhrConfig: xhrConfig
		});
	},
	getSpecialistsBlogAuthors: function getSpecialistsBlogAuthors(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/blog/authors',
			method: 'GET',
			actionType: GET_SPECIALISTS_BLOG_AUTHORS,
			keyword: 'author',
			xhrConfig: xhrConfig
		});
	},
	updateSelectedIndex: function updateSelectedIndex(index) {
		return {
			type: UPDATE_INDEX,
			index: index
		};
	},
	getPosts: function getPosts(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'blog/posts',
			method: 'GET',
			parameters: { page_number: 1, records_per_page: 5, filters: '' },
			actionType: GET_BLOG_POSTS,
			keyword: 'post',
			xhrConfig: xhrConfig
		});
	},
	getBlogMedia: function getBlogMedia(id, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'blog/media/' + id,
			method: 'GET',
			actionType: GET_BLOG_MEDIA,
			keyword: 'media',
			xhrConfig: xhrConfig
		});
	},
	getBlogPostCategories: function getBlogPostCategories(postId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'blog/posts/' + postId + '/categories',
			method: 'GET',
			actionType: GET_BLOG_POST_CATEGORIES,
			keyword: 'category',
			xhrConfig: xhrConfig
		});
	},
	getAuthorInfo: function getAuthorInfo(id, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'blog/authors/' + id,
			method: 'GET',
			actionType: GET_AUTHOR_INFO,
			keyword: 'author',
			xhrConfig: xhrConfig
		});
	}
};

exports.default = blogBannerActions;


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/blog-banner.js